import { AfterViewInit, Component, DoCheck, ElementRef, HostListener, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild, TemplateRef } from '@angular/core';
import { data, event } from 'jquery';
import { ControlService } from 'src/app/services/control.service';
import { LogcatService } from 'src/app/services/logcat.service';
import { SocketService } from 'src/app/services/socket.service';
import { ProcessMonitorService } from 'src/app/services/process-monitor-service.service';
import { filter } from 'rxjs';
import { Chart, ChartConfiguration, ChartDataset, ChartType } from 'chart.js/auto';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import * as io from 'socket.io-client';
declare let CanvasJS: any;
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LogcatTableComponent } from 'src/app/logcat-table/logcat-table.component';
import { NgChartsModule } from 'ng2-charts';

interface PerformanceData {
  uptime: number;
  realtime: number;
  app: {
    pid: number;
    packageName: string;
  };
  statsSince: number;
  frames: {
    totalFrames: number;
    jankyFrames: number;
    jankyFramesLegacy: number;
    percentiles: {
      p50: number;
      p90: number;
      p95: number;
      p99: number;
    };
    missedVsync: number;
    highInputLatency: number;
    slowUIThread: number;
    slowBitmapUploads: number;
    slowIssueDrawCommands: number;
    frameDeadlineMissed: number;
    frameDeadlineMissedLegacy: number;
    histogram: Record<string, number>;
  };
  gpuStats: {
    pipeline: string;
    gpuPercentiles: {
      p50: number;
      p90: number;
      p95: number;
      p99: number;
    };
    gpuHistogram: Record<string, number>;
  };
  memoryPolicy: {
    maxSurfaceArea: number;
    maxResourceUsageMB: number;
    backgroundRetentionPercent: number;
    gpuContextTimeoutSeconds: number;
  };
  contexts: {
    total: number;
    stopped: number;
  };
  cpuCaches: {
    glyphCacheSizeKB: number;
    glyphCount: number;
    totalCPUBytes: number;
    purgeableBytes: number;
  };
  gpuCaches: {
    other: number;
    image: number;
    scratch: {
      renderTarget: number;
      bufferObject: number;
      texture: number;
    };
    totalGPUMemoryBytes: number;
    purgeableGPUBytes: number;
  };
  viewHierarchy: {
    totalViewRoots: number;
    totalViews: number;
    totalRenderNodeUsedKB: number;
    totalRenderNodeCapacityKB: number;
  };
}

interface DropboxStatus {
  totalEntries: number;
  maxEntries: number;
  lowPriorityRateLimitMs: number;
  lowPriorityTags: string[];
  searchQuery: string;
  searchResult: string;
}

@Component({
  selector: 'app-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.css'],
  standalone: true,
  imports: [TranslateModule, CommonModule, FormsModule, LogcatTableComponent, NgChartsModule]
})
export class LogsComponent implements OnInit, OnDestroy, AfterViewInit {
  modalRef!: MatDialogRef<any>;
  @ViewChild('alertTemplate') alertTemplate: TemplateRef<any>;
  @Input() device: any;
  @ViewChild('systemUsageChart') private chartRef!: ElementRef;
  //for graph
  // @ViewChild('MyChart', { static: false }) chartRef!: ElementRef;
  // chart: any
  // socket!: ReturnType<typeof io.io>;
  // Properties to store historical data
  private performanceHistory: any[] = [];
  private appPerformanceHistory: any[] = [];
  cpuCores: number = 0;
  socket!: io.Socket;
  fromTime: string;
  private chart: Chart | null = null;
  updateInterval: any;
  updateGraphInterval: any;
  //for graph
  histogramChart: ChartConfiguration<'bar'>['data'];
  gpuHistogramChart: ChartConfiguration<'bar'>['data'];
  framePercentileChart: ChartConfiguration<'bar'>['data'];
  gpuPercentileChart: ChartConfiguration<'bar'>['data'];
  oldvalue: any = ''
  newvalue: any
  started: boolean = false;
  lognewvalue: boolean = false
  logoldvalue: boolean = false;
  selectedLevel: any;
  prop: any = [];
  performanceMatrix: any;
  activeTab: string = 'Logs';
  chartVisible: boolean = false;
  chartVisibleIos: boolean = false;
  isLoading: boolean = false;
  counter = 1;
  charts: any[] = [];
  msg: string;
  networkStats: any;
  networkCondition: any;
  pingStats: any;


  @Input() deviceserail: any;
  // @Input() control: ControlService;

  @ViewChild(LogcatTableComponent) logcatcalled: LogcatTableComponent;

  filters = {

    levelNumbers: [],
    priority: [],
    date: [],
    pid: [],
    tid: [],
    message: [],
    tag: []

  }

  pageWrapperHeight = '180px';

  private isResizing = false;
  private startY: number = 0;
  rawperformanceData: any;
  rawDumbsysData: any;
  performanceData: any;
  parsed: { packageName: string; activityName: string; };
  pageLoadingTime: { warning?: string; status?: string; launchState?: string; activity?: string; totalTime?: number; waitTime?: number; complete?: boolean; };
  appANR: DropboxStatus;

  private previousNetworkStats: {
    netBytesIn: number,
    netBytesOut: number,
    timestamp: number
  } | null = null;
  batteryUsage: any;



  constructor(
    private logcatservice: LogcatService,
    private socketService: SocketService,
    private control: ControlService,
    private processMonitoring: ProcessMonitorService,
    private dialog: MatDialog) {
    //for graph
    // this.initializeChart();
    //for graph
  }

  handleBeforeUnload() {

    //need to check
    // if (this.control) {
    //   for(let i = 0; i < this.logcatservice.deviceEntries.length ; i++) {
    //     if(this.logcatservice.deviceEntries[i] === this.deviceserail) {
    //       this.logcatservice.deviceEntries.splice(i, 1)
    //     }
    //   }
    //   this.logcatservice.deviceEntries[this.deviceserail].started = false
    //   this.control.stopLogcat()
    // }
  }

  ngOnInit(): void {
    window.onbeforeunload = null;
    window.onbeforeunload = null;

    let cleanDevice = (window.location.href).split('/').pop()
    this.cleanDeviceSettings()
    this.started = this.checkLogBtnStatus() === null ? false : this.checkLogBtnStatus()

    this.filters.levelNumbers = this.logcatservice.filters.levelNumbers
    this.filters.levelNumbers = this.logcatservice.filters.levelNumbers
    // this.logcatservice.filters.filterLines()

    this.restoreFilters()
    this.setFiltersPriority()

    this.defineFilterWatchers([
      'levelNumber',
      'message',
      'pid',
      'tid',
      'dateLabel',
      'date',
      'tag',
      'priority'
    ]);

    window.addEventListener('beforeunload', (event) => {
      event.preventDefault(); // Cancel the event
      this.handleBeforeUnload();
    });

  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.initializeChart();
      this.initializeChartIos();
    });
  }

  ngOnDestroy(): void {
    if (this.chart) {
      this.chart.destroy();
    }
  }

  openAlertMod(template: TemplateRef<any>, message: any) {
    this.modalRef = this.dialog.open(template, { width: '300px' });
    this.msg = message;
    setTimeout(() => {
      this.modalRef.close();;
      // setTimeout(() => {
      //   this.msg = "";
      // }, 2000)
      // this.msg = "";
    }, 2000)
  }

  Ok() {
    this.modalRef.close();;
  }

  cleanDeviceSettings() {
    //need to check  false
    // if (Object.keys($rootScope).includes('LogcatService')) {
    //   LogcatService.deviceEntries = $rootScope.LogcatService.deviceEntries


    if (Object.keys(this.logcatservice.deviceEntries).includes(this.deviceserail)) {
      if (this.logcatservice.deviceEntries[this.deviceserail].allowClean) {
        delete this.logcatservice.deviceEntries[this.deviceserail]
        if (this.control !== null) {
          this.control.stopLogcat()
        }
      }
    }

  }

  checkLogBtnStatus() {

    if (Object.keys(this.logcatservice.deviceEntries).includes(this.deviceserail)) {
      //pending
      //  if ($scope !== null && $scope.device !== null) {
      //   if($scope.device.logs_enabled && LogcatService.deviceEntries[deviceSerial].started) {
      //     return LogcatService.deviceEntries[deviceSerial].started
      //   }
      // }
      return null
    }
  }


  restoreFilters() {

    if (Object.keys(this.logcatservice.deviceEntries).includes(this.deviceserail)) {
      Object.keys(this.logcatservice.deviceEntries[this.deviceserail].filters).forEach(function (entry) {
        if ('filter.' + entry !== 'filter.priority') {
          this.filters[entry] = this.logcatservice.deviceEntries[this.deviceserail].filters[entry]
        } else {
          this.setFiltersPriority()
        }
      })
    }

  }

  setFiltersPriority() {
    if (Object.keys(this.logcatservice.deviceEntries).includes(this.deviceserail)) {
      this.filters.priority = this.filters.levelNumbers[
        this.logcatservice.deviceEntries[this.deviceserail].selectedLogLevel - 2]
    }
    // else {
    //   if (this.started) {
    //     // this.filters.priority = this.filters.levelNumbers[0]
    //   }
    // }
  }

  setActiveTab(str) {
    this.activeTab = str;
    setTimeout(() => {
      if (str == 'PT') {
        this.initializeChart();
        this.initializeChartIos();
      }
    }, 100);
  }

  defineFilterWatchers(props) {


    for (let index = 0; index < props.length; index++) {
      this.prop = props[index];
    }
  }

  loglevels(selectedValue) {
    this.newvalue = selectedValue;
    this.prop = 'priority';

    this.logcatservice.filterChar = this.newvalue.name;
    if (this.oldvalue = !this.newvalue) {
      this.oldvalue = this.newvalue
      let deviceSerial = (window.location.href).split('/').pop()
      this.logcatservice.filters[this.prop] = this.newvalue
    }

    if (!Object.keys(this.logcatservice.deviceEntries).includes(this.deviceserail)) {
      this.logcatservice.initDeviceLogCollector(this.deviceserail)
    }
    let transformedInput = ''
    switch ('filters.' + this.prop) {
      case 'filters.priority':
      case 'filters.levelNumber':
        if (this.newvalue !== null && !isNaN(this.newvalue.number)) {
          this.logcatservice.deviceEntries[this.deviceserail].selectedLogLevel = this.newvalue.number
          // this.filters.priority = this.filters.levelNumbers[
          //   this.logcatservice.deviceEntries[this.deviceserail].selectedLogLevel - 2]
          this.filters.priority = this.newvalue;
          transformedInput = this.logcatservice.deviceEntries[this.deviceserail].selectedLogLevel
        }
        break
      case 'filters.pid':
        transformedInput = this.newvalue.replace(/[^0-9:]/g, '')
        if (transformedInput !== this.newvalue) {
          this.filters.pid = transformedInput as any
        }
        break
      case 'filters.tid':
        transformedInput = this.newvalue.replace(/[^0-9]/g, '')
        if (transformedInput !== this.newvalue) {
          this.filters.tid = transformedInput as any
        }
        break
      default:
        transformedInput = this.newvalue
    }

    // Exclude Debug Level info
    if (this.prop !== 'levelNumber') {
      this.logcatservice.deviceEntries[this.deviceserail].filters[this.prop] = transformedInput
    }

    this.logcatservice.filters[this.prop] = transformedInput

    // Check if scope is defined check
    // if ($scope !== 'undefined') {
    //   this.setFiltersPriority()
    // }

    this.logcatservice.deviceEntries[this.deviceserail].allowClean = false
    this.logcatservice.allowClean = false
  }

  clear() {
    let deviceSerial = (window.location.href).split('/').pop()
    if (Object.keys(this.logcatservice.deviceEntries).includes(deviceSerial)) {
      for (let i = this.logcatservice.deviceSerial.length - 1; i >= 0; i++) {
        if (this.logcatservice.deviceSerial[i] === deviceSerial) {
          this.logcatservice.deviceSerial.splice(i, 1)
        }
      }
    }
  }

  Logscontrol() {
    this.started = !this.started;

    if (!Object.keys(this.logcatservice.deviceEntries).includes(this.deviceserail)) {
      this.logcatservice.deviceEntries[this.deviceserail] = {
        logs: [], selectedLogLevel: 2, started: false,
        filters: {
          'message': '',
          'pid': '',
          'tid': '',
          'dateLabel': '',
          'date': '',
          'tag': '',
          'priority': '',
        }
      }
      this.lognewvalue = this.started
      if (this.lognewvalue !== this.logoldvalue) {
        this.logoldvalue = this.lognewvalue
        this.logcatservice.deviceEntries[this.deviceserail].started = this.lognewvalue
        if (this.logcatservice.deviceEntries[this.deviceserail].started) {
          this.control.startLogcat([])
          this.logcatservice.deviceEntries[this.deviceserail].started = true
          // $scpe.device.logs_enabled = true
          this.setFiltersPriority()
        } else {
          if (Object.keys(this.logcatservice.deviceEntries).includes(this.deviceserail)) {
            this.logcatservice.deviceEntries[this.deviceserail].started = false
          }
          this.logcatservice.deviceEntries[this.deviceserail].started = false
          // $scope.device.logs_enabled = false
          // device.logs_enabled = false
          this.control.stopLogcat()
        }
      }
    }
  }

  clearTable() {
    this.logcatcalled.clear()
  }

  saveLogs() {
    this.logcatcalled.showsaveLogs();
  }


  /* for FPS, ANR rate, App & page loading times
     ===========================================
     ===========================================
     ===========================================
     ===========================================
     ===========================================
     =========================================== */
  appShell() {
    this.control.shell('dumpsys window | grep mCurrentFocus').then(output => {
      for (let i in output.data) this.rawDumbsysData += output.data[i];
      this.parsed = this.extractPackageAndActivity(this.rawDumbsysData);
      //Start collecting frame stats
      this.control.shell("dumpsys gfxinfo " + this.parsed.packageName + " reset").then(output => {
        setTimeout(async () => {
          // Frame rates
          this.control.shell("dumpsys gfxinfo " + this.parsed.packageName).then(data => {
            for (let i in data.data) {
              this.rawperformanceData += data.data[i];
            }
            this.performanceData = this.parseGraphicsInfo(this.rawperformanceData);
            // Storing history
            this.appPerformanceHistory.push(JSON.parse(JSON.stringify(this.performanceData)));

            // Keeping only last 100 snapshots
            if (this.appPerformanceHistory.length > 100) {
              this.appPerformanceHistory.shift();
            }
            this.histogramChart = this.prepareHistogramData(this.performanceData.frames.histogram, 'Frame Time Histogram');
            this.gpuHistogramChart = this.prepareHistogramData(this.performanceData.gpuStats.gpuHistogram, 'GPU Frame Time Histogram');

            this.framePercentileChart = this.preparePercentileData(this.performanceData.frames.percentiles, 'Frame Latency Percentiles');
            this.gpuPercentileChart = this.preparePercentileData(this.performanceData.gpuStats.gpuPercentiles, 'GPU Latency Percentiles');
          })
          await this.sleep(3000);
          // ANR history
          this.control.shell("dumpsys dropbox --print data_app_anr").then(data => {
            this.appANR = this.parseDropboxOutput(data.data[0]);
          })
          await this.sleep(3000);
          // App & page loading time
          this.control.shell("am start -W " + this.parsed.packageName + "/" + this.parsed.activityName).then(data => {
            this.pageLoadingTime = this.extractIntentDetails(data.data);
          })
          await this.sleep(3000);
          // Battery Usage Stats
          this.control.shell("dumpsys batterystats " + this.parsed.packageName).then(data => {
            let rawBatteryData = '';
            for (let i in data.data) {
              rawBatteryData += data.data[i];
            }
            this.batteryUsage = this.parseBatteryStats(rawBatteryData);
            console.log("battery Usage: ", this.batteryUsage, "\ndata: ", data);

          })
          await this.sleep(3000);
          // Network Stats
          this.control.shell('dumpsys window | grep mCurrentFocus').then(output => {
            for (let i in output.data) this.rawDumbsysData += output.data[i];
            this.parsed = this.extractPackageAndActivity(this.rawDumbsysData);

            this.control.shell("dumpsys gfxinfo " + this.parsed.packageName + " reset").then(output => {
              setTimeout(async () => {
                // ... existing code ...

                // Network Statistics
                this.control.shell("dumpsys netstats").then(data => {
                  let rawNetworkData = '';
                  for (let i in data.data) {
                    rawNetworkData += data.data[i];
                  }
                  this.networkStats = this.parseNetStatsData(rawNetworkData);
                })
                await this.sleep(3000);
                // Network Type and Connectivity
                this.control.shell("dumpsys connectivity").then(data => {
                  let rawConnectivityData = '';
                  for (let i in data.data) {
                    rawConnectivityData += data.data[i];
                  }
                  this.networkCondition = this.parseNetworkCondition(rawConnectivityData);
                })

                // Packet Loss and Latency (ping test)
                this.control.shell("ping -c 10 -W 1 8.8.8.8").then(data => {
                  let rawPingData = '';
                  for (let i in data.data) {
                    rawPingData += data.data[i];
                  }
                  this.pingStats = this.parsePingStats(rawPingData);
                })

              }, 2000)
            })
          });
        }, 2000)

      })
    });
  }

  async sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  // Updated Battery Stats Parser
  parseBatteryStats(data: string): any {
    const batteryStats = {
      estimatedPowerMah: 0,
      foregroundMs: 0,
      backgroundMs: 0,
      screenPowerMah: 0,
      cpuPowerMah: 0,
      wakeLocks: 0,
      dischargeMah: 0,
      screenOffDischargeMah: 0,
      screenOnDischargeMah: 0,
      estimatedBatteryCapacity: 0,
      timeOnBatteryMs: 0,
      screenOnTimeMs: 0
    };

    try {
      // Estimated battery capacity
      const capacityMatch = data.match(/Estimated battery capacity:\s*([\d,]+)\s*mAh/);
      if (capacityMatch) {
        batteryStats.estimatedBatteryCapacity = parseInt(capacityMatch[1].replace(/,/g, ''));
      }

      // Discharge amounts
      const dischargeMatch = data.match(/Discharge:\s*([\d,]+)\s*mAh/);
      if (dischargeMatch) {
        batteryStats.dischargeMah = parseInt(dischargeMatch[1].replace(/,/g, ''));
      }

      const screenOffDischargeMatch = data.match(/Screen off discharge:\s*([\d,]+)\s*mAh/);
      if (screenOffDischargeMatch) {
        batteryStats.screenOffDischargeMah = parseInt(screenOffDischargeMatch[1].replace(/,/g, ''));
      }

      const screenOnDischargeMatch = data.match(/Screen on discharge:\s*([\d,]+)\s*mAh/);
      if (screenOnDischargeMatch) {
        batteryStats.screenOnDischargeMah = parseInt(screenOnDischargeMatch[1].replace(/,/g, ''));
      }

      // Time on battery (parse from format like "16h 2m 3s 208ms")
      const timeOnBatteryMatch = data.match(/Time on battery:\s*(?:(\d+)h\s*)?(?:(\d+)m\s*)?(?:(\d+)s\s*)?(?:(\d+)ms)?/);
      if (timeOnBatteryMatch) {
        const hours = parseInt(timeOnBatteryMatch[1] || '0');
        const minutes = parseInt(timeOnBatteryMatch[2] || '0');
        const seconds = parseInt(timeOnBatteryMatch[3] || '0');
        const milliseconds = parseInt(timeOnBatteryMatch[4] || '0');
        batteryStats.timeOnBatteryMs = (hours * 3600000) + (minutes * 60000) + (seconds * 1000) + milliseconds;
      }

      // Screen on time
      const screenOnMatch = data.match(/Screen on:\s*(?:(\d+)h\s*)?(?:(\d+)m\s*)?(?:(\d+)s\s*)?(?:(\d+)ms)?/);
      if (screenOnMatch) {
        const hours = parseInt(screenOnMatch[1] || '0');
        const minutes = parseInt(screenOnMatch[2] || '0');
        const seconds = parseInt(screenOnMatch[3] || '0');
        const milliseconds = parseInt(screenOnMatch[4] || '0');
        batteryStats.screenOnTimeMs = (hours * 3600000) + (minutes * 60000) + (seconds * 1000) + milliseconds;
      }

      // Count wake locks
      const wakeLockMatches = data.match(/Wake lock/g);
      if (wakeLockMatches) {
        batteryStats.wakeLocks = wakeLockMatches.length;
      }

      // Get estimated power use breakdown
      const screenPowerMatch = data.match(/screen:\s*([\d.]+)/i);
      if (screenPowerMatch) {
        batteryStats.screenPowerMah = parseFloat(screenPowerMatch[1]);
      }

      const cpuPowerMatch = data.match(/cpu:\s*([\d.]+)/i);
      if (cpuPowerMatch) {
        batteryStats.cpuPowerMah = parseFloat(cpuPowerMatch[1]);
      }

    } catch (error) {
      console.error('Error parsing battery stats:', error);
    }

    return batteryStats;
  }

  // Enhanced Network Stats Parser
  parseNetStatsData(data: string): any {
    const networkStats = {
      mobileRxBytes: 0,
      mobileTxBytes: 0,
      mobileRxPackets: 0,
      mobileTxPackets: 0,
      wifiRxBytes: 0,
      wifiTxBytes: 0,
      wifiRxPackets: 0,
      wifiTxPackets: 0,
      totalRxBytes: 0,
      totalTxBytes: 0,
      estimatedPacketLoss: 0  // Will be calculated
    };

    try {
      // Look for the interface stats map section
      const ifaceStatsMatch = data.match(/mIfaceStatsMap:[\s\S]*?(?=\n\n|$)/);

      if (ifaceStatsMatch) {
        const ifaceStats = ifaceStatsMatch[0];

        // Parse each interface
        const interfaceRegex = /ifaceIndex=\d+\s+ifaceName=(\w+)\s+rxBytes=([\d,]+)\s+rxPackets=([\d,]+)\s+txBytes=([\d,]+)\s+txPackets=([\d,]+)/g;
        let match;

        while ((match = interfaceRegex.exec(ifaceStats)) !== null) {
          const ifaceName = match[1];
          const rxBytes = parseInt(match[2].replace(/,/g, ''));
          const rxPackets = parseInt(match[3].replace(/,/g, ''));
          const txBytes = parseInt(match[4].replace(/,/g, ''));
          const txPackets = parseInt(match[5].replace(/,/g, ''));

          // Check if it's a WiFi interface (wlan, wifi)
          if (ifaceName.match(/wlan|wifi/i)) {
            networkStats.wifiRxBytes += rxBytes;
            networkStats.wifiRxPackets += rxPackets;
            networkStats.wifiTxBytes += txBytes;
            networkStats.wifiTxPackets += txPackets;
          }
          // Check if it's a mobile interface (rmnet, ccmni, mobile, etc.)
          else if (ifaceName.match(/rmnet|ccmni|mobile|pdp/i)) {
            networkStats.mobileRxBytes += rxBytes;
            networkStats.mobileRxPackets += rxPackets;
            networkStats.mobileTxBytes += txBytes;
            networkStats.mobileTxPackets += txPackets;
          }
        }
      }

      // Calculate totals
      networkStats.totalRxBytes = networkStats.mobileRxBytes + networkStats.wifiRxBytes;
      networkStats.totalTxBytes = networkStats.mobileTxBytes + networkStats.wifiTxBytes;

      // Estimate packet loss (very rough - based on TX vs RX packet ratio)
      const totalTxPackets = networkStats.wifiTxPackets + networkStats.mobileTxPackets;
      const totalRxPackets = networkStats.wifiRxPackets + networkStats.mobileRxPackets;

      if (totalTxPackets > 0) {
        // This is a very rough estimate - not accurate packet loss
        networkStats.estimatedPacketLoss = Math.max(0, ((totalTxPackets - totalRxPackets) / totalTxPackets) * 100);
      }

      console.log('Parsed network stats:', networkStats);

    } catch (error) {
      console.error('Error parsing network stats:', error);
    }

    return networkStats;
  }

  // Parse Network Type and Connectivity
  parseNetworkCondition(data: string): any {
    const condition = {
      networkType: 'Unknown',
      isConnected: false,
      isWifiConnected: false,
      isMobileConnected: false,
      signalStrength: 'Unknown',
      networkSubtype: 'Unknown',
      isOffline: true
    };

    try {
      // Check if connected
      const connectedMatch = data.match(/state:\s*CONNECTED/i);
      condition.isConnected = !!connectedMatch;
      condition.isOffline = !connectedMatch;

      // Check WiFi connection
      const wifiMatch = data.match(/NetworkAgentInfo.*WIFI.*state:\s*CONNECTED/i);
      condition.isWifiConnected = !!wifiMatch;

      // Check Mobile connection
      const mobileMatch = data.match(/NetworkAgentInfo.*MOBILE.*state:\s*CONNECTED/i);
      condition.isMobileConnected = !!mobileMatch;

      // Determine network type
      if (condition.isWifiConnected) {
        condition.networkType = 'Wi-Fi';
      } else if (condition.isMobileConnected) {
        // Try to determine mobile network type
        const lteMatch = data.match(/LTE|4G/i);
        const fiveGMatch = data.match(/NR|5G/i);
        const threeDMatch = data.match(/UMTS|HSPA|3G/i);

        if (fiveGMatch) {
          condition.networkType = '5G';
          condition.networkSubtype = '5G';
        } else if (lteMatch) {
          condition.networkType = '4G/LTE';
          condition.networkSubtype = 'LTE';
        } else if (threeDMatch) {
          condition.networkType = '3G';
          condition.networkSubtype = '3G/HSPA';
        } else {
          condition.networkType = 'Mobile Data';
          condition.networkSubtype = 'Unknown';
        }
      }

      // Get signal strength (if available)
      const signalMatch = data.match(/SignalStrength:\s*(-?\d+)/i);
      if (signalMatch) {
        const signalValue = parseInt(signalMatch[1]);
        if (signalValue > -50) condition.signalStrength = 'Excellent';
        else if (signalValue > -70) condition.signalStrength = 'Good';
        else if (signalValue > -85) condition.signalStrength = 'Fair';
        else condition.signalStrength = 'Poor';
      }

    } catch (error) {
      console.error('Error parsing network condition:', error);
    }

    return condition;
  }

  // Parse Ping Statistics (Latency and Packet Loss)
  parsePingStats(data: string): any {
    const pingStats = {
      packetsSent: 0,
      packetsReceived: 0,
      packetLoss: 0,
      minLatency: 0,
      avgLatency: 0,
      maxLatency: 0,
      hasHighLatency: false,
      isReachable: false
    };

    try {
      // Parse packet statistics
      // Format: "10 packets transmitted, 8 received, 20% packet loss"
      const packetMatch = data.match(/(\d+)\s+packets transmitted,\s*(\d+)\s+received,\s*([\d.]+)%\s+packet loss/i);

      if (packetMatch) {
        pingStats.packetsSent = parseInt(packetMatch[1]);
        pingStats.packetsReceived = parseInt(packetMatch[2]);
        pingStats.packetLoss = parseFloat(packetMatch[3]);
        pingStats.isReachable = pingStats.packetsReceived > 0;
      }

      // Parse latency statistics
      // Format: "rtt min/avg/max/mdev = 12.345/23.456/34.567/4.567 ms"
      const rttMatch = data.match(/rtt min\/avg\/max(?:\/mdev)?\s*=\s*([\d.]+)\/([\d.]+)\/([\d.]+)/i);

      if (rttMatch) {
        pingStats.minLatency = parseFloat(rttMatch[1]);
        pingStats.avgLatency = parseFloat(rttMatch[2]);
        pingStats.maxLatency = parseFloat(rttMatch[3]);

        // Consider high latency if average > 100ms
        pingStats.hasHighLatency = pingStats.avgLatency > 100;
      }

    } catch (error) {
      console.error('Error parsing ping stats:', error);
    }

    return pingStats;
  }

  // Helper function to convert data units to bytes
  private convertToBytes(value: number, unit: string): number {
    const units: { [key: string]: number } = {
      'B': 1,
      'KB': 1024,
      'MB': 1024 * 1024,
      'GB': 1024 * 1024 * 1024,
      'TB': 1024 * 1024 * 1024 * 1024
    };

    return Math.round(value * (units[unit] || 1));
  }

  // Helper function to format milliseconds to readable time
  formatTime(ms: number): string {
    if (!ms) return '0s';

    const hours = Math.floor(ms / 3600000);
    const minutes = Math.floor((ms % 3600000) / 60000);
    const seconds = Math.floor((ms % 60000) / 1000);

    const parts = [];
    if (hours > 0) parts.push(`${hours}h`);
    if (minutes > 0) parts.push(`${minutes}m`);
    if (seconds > 0) parts.push(`${seconds}s`);

    return parts.join(' ') || '0s';
  }


  extractPackageAndActivity(dumpOutput: string): { packageName: string; activityName: string } | null {
    const match = dumpOutput.match(/mCurrentFocus=Window\{[^\s]+ u\d+ ([^\/]+)\/([^\}]+)\}/);
    if (match && match.length >= 3) {
      return {
        packageName: match[1],
        activityName: match[2],
      };
    }
    return null;
  }

  extractIntentDetails(logs: string[]): {
    warning?: string;
    status?: string;
    launchState?: string;
    activity?: string;
    totalTime?: number;
    waitTime?: number;
    complete?: boolean;
  } {
    const log = logs.join(' '); // Flatten into one string for regex processing

    const warningMatch = log.match(/Warning:\s(.+?)\sStatus:/);
    const statusMatch = log.match(/Status:\s(.+?)\sLaunchState:/);
    const launchStateMatch = log.match(/LaunchState:\s(.+?)\sActivity:/);
    const activityMatch = log.match(/Activity:\s([^\s]+)/);
    const totalTimeMatch = log.match(/TotalTime:\s(\d+)/);
    const waitTimeMatch = log.match(/WaitTime:\s(\d+)/);
    const completeMatch = log.match(/Complete/);

    return {
      warning: warningMatch?.[1],
      status: statusMatch?.[1],
      launchState: launchStateMatch?.[1],
      activity: activityMatch?.[1],
      totalTime: totalTimeMatch ? Number(totalTimeMatch[1]) : undefined,
      waitTime: waitTimeMatch ? Number(waitTimeMatch[1]) : undefined,
      complete: !!completeMatch,
    };
  }

  parseDropboxOutput(raw: string): DropboxStatus {
    const totalEntries = Number(raw.match(/Drop box contents:\s+(\d+)/)?.[1] || 0);
    const maxEntries = Number(raw.match(/Max entries:\s+(\d+)/)?.[1] || 0);
    const rateLimit = Number(raw.match(/Low priority rate limit period:\s+(\d+)\s+ms/)?.[1] || 0);

    const tagsMatch = raw.match(/Low priority tags:\s+\{(.+?)\}/);
    const tags = tagsMatch ? tagsMatch[1].split(',').map(tag => tag.trim()) : [];

    const searchQuery = raw.match(/Searching for:\s+(.+)/)?.[1] || '';
    const searchResult = raw.includes('No entries found') ? 'No entries found' : 'Entries found';

    return {
      totalEntries,
      maxEntries,
      lowPriorityRateLimitMs: rateLimit,
      lowPriorityTags: tags,
      searchQuery,
      searchResult
    };
  }


  parseGraphicsInfo(raw: string): PerformanceData {
    const getNumber = (text: string, regex: RegExp, fallback = 0) => {
      const match = text.match(regex);
      return match ? Number(match[1]) : fallback;
    };

    const getRecord = (text: string, regex: RegExp): Record<string, number> => {
      const match = text.match(regex);
      if (!match) return {};
      const entries = match[1].split(' ').filter(Boolean).map(entry => {
        const [key, value] = entry.split('=');
        return [key.replace('ms', ''), Number(value)];
      });
      return Object.fromEntries(entries);
    };

    return {
      uptime: getNumber(raw, /Uptime:\s+(\d+)/),
      realtime: getNumber(raw, /Realtime:\s+(\d+)/),
      app: {
        pid: getNumber(raw, /\[com\.vivo\.gallery\].*?pid\s(\d+)/),
        packageName: this.parsed.packageName
      },
      statsSince: getNumber(raw, /Stats since:\s+(\d+)/),
      frames: {
        totalFrames: getNumber(raw, /Total frames rendered:\s+(\d+)/),
        jankyFrames: getNumber(raw, /Janky frames:\s+(\d+)/),
        jankyFramesLegacy: getNumber(raw, /Janky frames \(legacy\):\s+(\d+)/),
        percentiles: {
          p50: getNumber(raw, /50th percentile:\s+(\d+)/),
          p90: getNumber(raw, /90th percentile:\s+(\d+)/),
          p95: getNumber(raw, /95th percentile:\s+(\d+)/),
          p99: getNumber(raw, /99th percentile:\s+(\d+)/),
        },
        missedVsync: getNumber(raw, /Number Missed Vsync:\s+(\d+)/),
        highInputLatency: getNumber(raw, /Number High input latency:\s+(\d+)/),
        slowUIThread: getNumber(raw, /Number Slow UI thread:\s+(\d+)/),
        slowBitmapUploads: getNumber(raw, /Number Slow bitmap uploads:\s+(\d+)/),
        slowIssueDrawCommands: getNumber(raw, /Number Slow issue draw commands:\s+(\d+)/),
        frameDeadlineMissed: getNumber(raw, /Number Frame deadline missed:\s+(\d+)/),
        frameDeadlineMissedLegacy: getNumber(raw, /Number Frame deadline missed \(legacy\):\s+(\d+)/),
        histogram: getRecord(raw, /HISTOGRAM:\s+(.*?)(?=50th gpu percentile)/s)
      },
      gpuStats: {
        pipeline: raw.includes('Pipeline=Skia (OpenGL)') ? 'Skia (OpenGL)' : 'unknown',
        gpuPercentiles: {
          p50: getNumber(raw, /50th gpu percentile:\s+(\d+)/),
          p90: getNumber(raw, /90th gpu percentile:\s+(\d+)/),
          p95: getNumber(raw, /95th gpu percentile:\s+(\d+)/),
          p99: getNumber(raw, /99th gpu percentile:\s+(\d+)/),
        },
        gpuHistogram: getRecord(raw, /GPU HISTOGRAM:\s+(.*?)(?=Pipeline)/s)
      },
      memoryPolicy: {
        maxSurfaceArea: getNumber(raw, /Max surface area:\s+(\d+)/),
        maxResourceUsageMB: getNumber(raw, /Max resource usage:\s+([\d\.]+)MB/),
        backgroundRetentionPercent: getNumber(raw, /Background retention:\s+(\d+)%/),
        gpuContextTimeoutSeconds: getNumber(raw, /GPU Context timeout:\s+(\d+)/),
      },
      contexts: {
        total: getNumber(raw, /Contexts:\s+(\d+)/),
        stopped: getNumber(raw, /stopped\s+=\s+(\d+)/)
      },
      cpuCaches: {
        glyphCacheSizeKB: getNumber(raw, /Glyph Cache:\s+([\d\.]+) KB/),
        glyphCount: getNumber(raw, /Glyph Count:\s+(\d+)/),
        totalCPUBytes: getNumber(raw, /Total CPU memory usage:\s+(\d+) bytes/),
        purgeableBytes: getNumber(raw, /\(([\d\.]+) bytes is purgeable\)/)
      },
      gpuCaches: {
        other: getNumber(raw, /Other:\s+([\d\.]+) KB/),
        image: getNumber(raw, /Texture:\s+([\d\.]+) MB \(30 entries\)/),
        scratch: {
          renderTarget: getNumber(raw, /RenderTarget:\s+([\d\.]+) MB/),
          bufferObject: getNumber(raw, /Buffer Object:\s+([\d\.]+) KB/),
          texture: getNumber(raw, /Texture:\s+([\d\.]+) MB \(1 entry\)/),
        },
        totalGPUMemoryBytes: getNumber(raw, /Total GPU memory usage:\s+(\d+) bytes/),
        purgeableGPUBytes: getNumber(raw, /\(([\d\.]+) MB is purgeable\)/)
      },
      viewHierarchy: {
        totalViewRoots: getNumber(raw, /Total ViewRootImpl\s+:\s+(\d+)/),
        totalViews: getNumber(raw, /Total attached Views\s+:\s+(\d+)/),
        totalRenderNodeUsedKB: getNumber(raw, /(\d+\.\d+) kB \(used\)/),
        totalRenderNodeCapacityKB: getNumber(raw, /\/ (\d+\.\d+) kB \(capacity\)/)
      }
    };
  }

  prepareHistogramData(histogram: Record<string, number>, label: string) {
    const filtered = Object.entries(histogram)
      .filter(([_, v]) => typeof v === 'number' && v > 0);

    const labels = filtered.map(([k]) => k);
    const values = filtered.map(([_, v]) => v as number);

    return {
      labels,
      datasets: [{
        label,
        data: values,
        backgroundColor: '#66BB6A'
      }]
    };
  }

  preparePercentileData(percentiles: Record<string, number>, label: string) {
    const labels = Object.keys(percentiles);
    const values = Object.values(percentiles);
    return {
      labels,
      datasets: [{
        label,
        data: values,
        backgroundColor: '#42A5F5'
      }]
    };
  }

  axisOptions(xLabel: string, yLabel: string) {
    return {
      responsive: true,
      scales: {
        x: {
          title: {
            display: true,
            text: xLabel
          }
        },
        y: {
          title: {
            display: true,
            text: yLabel
          },
          beginAtZero: true
        }
      },
      plugins: {
        legend: {
          display: false
        }
      }
    };
  }


  /* for FPS, ANR rate, App & page loading times
       ===========================================
       ===========================================
       ===========================================
       ===========================================
       ===========================================
       =========================================== */

  //check
  validateInput(event: KeyboardEvent) {
    const charCode = event.charCode;
    if (charCode !== 0) {
      const charStr = String.fromCharCode(charCode);
      if (!charStr.match(/^[0-9]+$/)) {
        event.preventDefault();
      }
    }
  }
  //check
  sanitizeInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, '');
  }


  validateDate(event: KeyboardEvent) {

    const charCode = event.charCode;
    const charStr = String.fromCharCode(charCode);
    const input = event.target as HTMLInputElement;

    if (charCode !== 0) {
      if (!charStr.match(/^[0-9.]$/) || (charStr === '.' && input.value.includes('.'))) {
        event.preventDefault();
      }
    }
  }

  sanitizeInputDate(event: Event) {
    const input = event.target as HTMLInputElement;
    const sanitizedValue = input.value.replace(/[^0-9.]/g, '');

    // Allow only one decimal point
    const parts = sanitizedValue.split('.');
    if (parts.length > 2) {
      input.value = `${parts[0]}.${parts.slice(1).join('')}`;
    } else {
      input.value = sanitizedValue;
    }

    input.dispatchEvent(new Event('input')); // Ensure ngModel is updated

  }

  threeShell() {
    this.fromTime = new Date().toLocaleString();
    if (this.device.platform == "iOS") {
      this.chartVisibleIos = !this.chartVisibleIos;

      if (this.chartVisibleIos) {
        this.isLoading = true;
        this.counter = 1;

        // Optional animation/loading counter
        const interval = setInterval(() => {
          if (this.counter > 3) {
            clearInterval(interval);
          }
          this.counter++;
        }, 2000);

        // Initialize chart after DOM is ready
        setTimeout(() => {
          this.initializeChartIos();
        }, 0);

        // Connect to Socket.IO server
        this.connectToSocket();

      } else {
        this.isLoading = false;

        // Destroy the chart if exists
        if (this.chart) {
          this.chart.destroy();
          this.chart = null;
        }

        // Disconnect socket if active
        if (this.socket) {
          this.socket.disconnect();
          this.socket = null;
        }

        // Clear any chart update intervals (if applicable)
        if (this.updateGraphInterval) {
          clearInterval(this.updateGraphInterval);
          this.updateGraphInterval = null;
        }
      }
    } else {
      this.cpuCores = this.control.shell('cat /sys/devices/system/cpu/present').then(data => {
        let cores = data.data[0].trim().split('-');
        this.cpuCores = parseInt(cores[1]) + 1;
      });
      //initialization should be written in afterviewinit but for now its written here.
      this.chartVisible = !this.chartVisible;
      if (this.chartVisible) {
        let interval = setInterval(() => {
          if (this.counter > 3)
            interval = null
          this.counter++;
        }, 2000)
        // this.initializeChart();
        this.isLoading = true;
        this.updateGraphInterval = setInterval(() => {
          this.control.shell('top').then(data => {
            this.isLoading = false;
            this.performanceMatrix = this.processMonitoring.parseSystemData(data.data);
            // Storing history for averaging
            this.performanceHistory.push(JSON.parse(JSON.stringify(this.performanceMatrix)));

            // Only last 100 snapshots to prevent memory issues
            if (this.performanceHistory.length > 100) {
              this.performanceHistory.shift();
            }
            this.startPeriodicUpdate();
            this.updateChartData(this.performanceMatrix);
          });
        }, 5000)
      } else {
        if (this.isLoading)
          this.isLoading = false;
        clearInterval(this.updateGraphInterval);
        clearInterval(this.updateInterval);
        // Clear history
        this.performanceHistory = [];
        this.appPerformanceHistory = [];
        this.chart.data = {
          labels: [],
          datasets: [
            {
              label: 'Total Memory Usage (%)',
              data: [],
              backgroundColor: 'transparent',
              borderColor: 'rgba(255, 99, 132, 1)',
            },
            {
              label: 'userPercent (%)',
              data: [],
              backgroundColor: 'transparent',
              borderColor: 'rgba(75, 192, 192, 1)',
            },
            {
              label: 'nicePercent (%)',
              data: [],
              backgroundColor: 'transparent',
              borderColor: 'rgba(54, 162, 235, 1)',
            },
            {
              label: 'sysPercent (%)',
              data: [],
              backgroundColor: 'transparent',
              borderColor: 'rgba(255, 206, 86, 1)',
            },
            {
              label: 'iowPercent (%)',
              data: [],
              backgroundColor: 'transparent',
              borderColor: 'rgba(153, 102, 255, 1)',
            },
            {
              label: 'irqPercent (%)',
              data: [],
              backgroundColor: 'transparent',
              borderColor: 'rgba(255, 159, 64, 1)',
            },
            {
              label: 'sirqPercent (%)',
              data: [],
              backgroundColor: 'transparent',
              borderColor: 'rgba(199, 199, 199, 1)',
            },
            {
              label: 'hostPercent (%)',
              data: [],
              backgroundColor: 'transparent',
              borderColor: 'rgba(83, 102, 255, 1)',
            }
          ]
        };
        // this.chart.destroy();
      }
    }
  }



  //of no use
  // initializeChart() {
  //   const ctx = this.chartRef.nativeElement.getContext('2d');
  //   this.chart = new Chart(ctx, {
  //     type: 'line',
  //     data: {
  //       labels: [],
  //       datasets: [
  //         {
  //           label: 'CPU Total Load (%)',
  //           data: [],
  //           backgroundColor: 'blue',
  //           borderColor: 'blue',
  //           fill: false,
  //           tension: 0.1,
  //         },
  //       ],
  //     },
  //     options: {
  //       responsive: true,
  //       aspectRatio: 2.5,
  //       plugins: {
  //         title: {
  //           display: true,
  //           text: 'Real-Time CPU Total Load',
  //         },
  //       },
  //       scales: {
  //         y: {
  //           beginAtZero: true,
  //           max: 200,
  //           title: {
  //             display: true,
  //             text: 'CPU Load (%)',
  //           },
  //         },
  //         x: {
  //           title: {
  //             display: true,
  //             text: 'Time',
  //           },
  //         },
  //       },
  //     },
  //   });
  // }

  generateMetricSeries(name: string, color: string): { type: string, name: string, showInLegend: boolean, dataPoints: any[] } {
    let dataPoints = [];
    let value = Math.random() * 100;

    for (let i = 0; i < 20; i++) {
      value += Math.random() * 10 - 5;
      dataPoints.push({
        x: Date.now() - (20 - i) * 1000, // 1 second apart, starting 20s ago
        y: parseFloat(value.toFixed(2))
      });
    }

    return {
      type: "splineArea",
      name,
      showInLegend: true,
      dataPoints,
      color // ← TS may complain, so assert:
    } as any;
  }

  initializeChartIos() {
    const syncToolTip = (e: any) => {
      for (let chart of this.charts) {
        if (chart !== e.chart) {
          chart.toolTip.showAtX(e.dataPoint.x, 0);
        }
      }
    };

    const baseOptions = {
      animationEnabled: true,
      exportEnabled: true,
      axisX: {
        valueFormatString: "HH:mm:ss",
        crosshair: {
          enabled: true,
          snapToDataPoint: true
        }
      },
      axisY: {
        crosshair: {
          enabled: true
        }
      },
      toolTip: {
        shared: true,
        updated: syncToolTip
      },
      zoomEnabled: true,
      legend: {
        cursor: "pointer",
        itemclick: function (e: any) {
          if (typeof e.dataSeries.visible === "undefined" || e.dataSeries.visible) {
            e.dataSeries.visible = false;
          } else {
            e.dataSeries.visible = true;
          }
          e.chart.render();
        }
      }
    };

    // CPU Chart
    this.charts = [];
    this.charts.push(new CanvasJS.Chart("chartContainer1", {
      ...baseOptions,
      title: {
        text: "CPU Utilization",
        fontSize: 14
      },
      axisY: { ...baseOptions.axisY, suffix: "%" },
      data: [
        this.generateMetricSeries("Total", "#64b5f6"),
        this.generateMetricSeries("System", "#2196f3"),
        this.generateMetricSeries("Wait", "#1976d2")
      ]
    }));

    // Memory Chart
    this.charts.push(new CanvasJS.Chart("chartContainer2", {
      ...baseOptions,
      title: {
        text: "Memory Usage",
        fontSize: 14
      },
      axisY: { ...baseOptions.axisY, suffix: " MB" },
      data: [
        this.generateMetricSeries("Used", "#d32f2f"),
        this.generateMetricSeries("Free", "#f44336"),
        this.generateMetricSeries("Compressed", "#e57373"),
        this.generateMetricSeries("Swap", "#ef5350")
      ]
    }));

    // Network Chart
    this.charts.push(new CanvasJS.Chart("chartContainer3", {
      ...baseOptions,
      title: {
        text: "Network Traffic",
        fontSize: 14
      },
      axisY: { ...baseOptions.axisY, suffix: " Kb/s" },
      data: [
        this.generateMetricSeries("Inbound", "#388e3c"),
        this.generateMetricSeries("Outbound", "#81c784")
      ]
    }));

    // Disk Chart
    this.charts.push(new CanvasJS.Chart("chartContainer4", {
      ...baseOptions,
      title: {
        text: "Disk I/O (IOPS)",
        fontSize: 14
      },
      axisY: { ...baseOptions.axisY, suffix: " ops/sec" },
      data: [
        this.generateMetricSeries("Read", "#f57c00"),
        this.generateMetricSeries("Write", "#ffb74d")
      ]
    }));

    // Finally render all
    this.charts.forEach(chart => chart.render());
  }

  private connectToSocket() {
    // this.socket = io('ws://192.168.8.229:5001');
    this.socket = io.io('http://192.168.8.229:5001', {
      transports: ['websocket']
    });

    this.socket.on('connect', () => {
      // console.log('Connected to WebSocket server');
    });

    this.socket.on('00008101-000244401A22001E', (data) => {
      const parsed = typeof data === 'string' ? JSON.parse(data) : data;
      const now = new Date();
      const currentTimestamp = now.getTime();
      const xValue = now;

      const memoryChart = this.charts[1]; // Memory
      const networkChart = this.charts[2]; // Network
      const diskChart = this.charts[3]; // Disk

      // MEMORY CHART
      const memoryMetrics = ['used', 'free', 'compressed', 'swap'];
      memoryMetrics.forEach((key, index) => {
        const yValue = parsed[key];
        if (typeof yValue === 'number') {
          memoryChart.options.data[index].dataPoints.push({ x: xValue, y: yValue });

          if (memoryChart.options.data[index].dataPoints.length > 20) {
            memoryChart.options.data[index].dataPoints.shift();
          }
        }
      });

      memoryChart.render();

      // NETWORK CHART
      const networkMetrics = ['netBytesIn', 'netBytesOut'];
      networkMetrics.forEach((key, index) => {
        const yValue = parsed[key];
        if (typeof yValue === 'number') {
          networkChart.options.data[index].dataPoints.push({ x: xValue, y: yValue });
          if (networkChart.options.data[index].dataPoints.length > 20) {
            networkChart.options.data[index].dataPoints.shift();
          }
        }
      });
      networkChart.render();

      // DISK CHART
      const diskMetrics = ['read', 'write'];
      diskMetrics.forEach((key, index) => {
        const yValue = parsed[key];
        if (typeof yValue === 'number') {
          diskChart.options.data[index].dataPoints.push({ x: xValue, y: yValue });
          if (memoryChart.options.data[index].dataPoints.length > 20) {
            memoryChart.options.data[index].dataPoints.shift();
          }
        }
      });
      diskChart.render();

    });
  }




  public initializeChart() {
    console.log('Initializing chart...');

    if (!this.chartRef) {
      // console.error('Chart reference is undefined');
      return;
    }
    const ctx = this.chartRef.nativeElement.getContext('2d');

    const config: ChartConfiguration = {
      type: 'line',
      data: {
        labels: [], // Will be populated dynamically
        datasets: this.generateCoreDatasets()
      },
      options: {
        responsive: true,
        plugins: {
          title: {
            display: true,
            text: 'Performance Graph'
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            max: 350,
            title: {
              display: true,
              text: 'Usage Percentage'
            }
          },
          x: {
            title: {
              display: true,
              text: 'Time'
            }
          }
        },
        interaction: {
          mode: 'nearest',
          intersect: false
        }
      }
    };

    this.chart = new Chart(ctx, config);
  }

  // Generate datasets dynamically based on number of cores
  private generateCoreDatasets(): ChartDataset[] {
    const datasets: ChartDataset[] = [
      {
        label: 'Total Memory Usage (%)',
        data: [],
        borderColor: 'rgba(255, 99, 132, 1)',
        backgroundColor: 'rgba(255, 99, 132, 0.2)',
        fill: true
      }
    ];

    // Add datasets for each potential core (up to 8 cores)
    const coreColors = [
      'rgba(75, 192, 192, 1)',   // Teal
      'rgba(54, 162, 235, 1)',   // Blue
      'rgba(255, 206, 86, 1)',   // Yellow
      'rgba(153, 102, 255, 1)',  // Purple
      'rgba(255, 159, 64, 1)',   // Orange
      'rgba(199, 199, 199, 1)',  // Grey
      'rgba(83, 102, 255, 1)',   // Indigo
    ];

    let cpuAllocations = ['userPercent (%)', 'nicePercent (%)', 'sysPercent (%)', 'iowPercent (%)', 'irqPercent (%)', 'sirqPercent (%)', 'hostPercent (%)']

    for (let i = 1; i <= 7; i++) {
      datasets.push({
        label: cpuAllocations[i - 1],
        data: [],
        borderColor: coreColors[i - 1],
        backgroundColor: coreColors[i - 1].replace('1)', '0.2)'),
        fill: true
      });
    }

    return datasets;
  }

  // updateChartData(performanceMatrix: any) {
  //   if (!this.chart) {
  //     console.error('Chart is not initialized');
  //     return;
  //   }

  //   const currentTime = new Date().toLocaleTimeString();
  //   const data = this.chart.data;

  //   // Add timestamp
  //   data.labels?.push(currentTime);

  //   // Update memory usage (first dataset)
  //   (data.datasets[0].data as number[]).push(
  //     performanceMatrix.memoryUsagePercent || 0
  //   );

  //   // Update core-specific CPU usages
  //   performanceMatrix.coreUsages.forEach((core, index) => {
  //     // Map each CPU usage type to its corresponding dataset
  //     // Note: index + 1 to skip the memory usage dataset
  //     (data.datasets[1].data as number[]).push(core.cpuUsed.user); // userPercent
  //     (data.datasets[2].data as number[]).push(core.cpuUsed.nice); // nicePercent
  //     (data.datasets[3].data as number[]).push(core.cpuUsed.system); // sysPercent
  //     (data.datasets[4].data as number[]).push(core.cpuUsed.iow); // iowPercent
  //     (data.datasets[5].data as number[]).push(core.cpuUsed.irq); // irqPercent
  //     (data.datasets[6].data as number[]).push(core.cpuUsed.sirq); // sirqPercent
  //     (data.datasets[7].data as number[]).push(core.cpuUsed.host); // hostPercent
  //   });

  //   // Limit to last 20 data points
  //   const MAX_POINTS = 20;
  //   if (data.labels!.length > MAX_POINTS) {
  //     data.labels?.splice(0, data.labels.length - MAX_POINTS);
  //     data.datasets.forEach(dataset => {
  //       dataset.data.splice(0, dataset.data.length - MAX_POINTS);
  //     });
  //   }

  //   // Update the chart
  //   try {
  //     this.chart.update('none');
  //   } catch (error) {
  //     console.error('Error updating chart:', error);
  //   }
  // }

  updateChartData(performanceMatrix: any) {
    if (!this.chart) {
      console.error('Chart is not initialized');
      return;
    }
    //check for stop showing params
    if (this.chartVisible == false) {
      return;
    }

    const currentTime = new Date().toLocaleTimeString();
    const data = this.chart.data;

    // Ensure labels array exists
    data.labels = data.labels || [];
    data.labels.push(currentTime);

    // Ensure datasets array exists with at least 8 datasets
    data.datasets = data.datasets || [];

    // Ensure each dataset exists and has a .data array
    for (let i = 0; i <= 7; i++) {
      if (!data.datasets[i]) {
        data.datasets[i] = {
          label: `Dataset ${i}`,
          data: [],
          borderColor: `hsl(${i * 45}, 100%, 50%)`,
          backgroundColor: 'transparent',
        };
      }
      data.datasets[i].data = data.datasets[i].data || [];
    }

    // Add memory usage (index 0)
    data.datasets[0].data.push(performanceMatrix.memoryUsagePercent || 0);

    // Add CPU core usage
    performanceMatrix.coreUsages?.forEach((core, index) => {
      data.datasets[1].data.push(core.cpuUsed.user);   // userPercent
      data.datasets[2].data.push(core.cpuUsed.nice);   // nicePercent
      data.datasets[3].data.push(core.cpuUsed.system); // sysPercent
      data.datasets[4].data.push(core.cpuUsed.iow);    // iowPercent
      data.datasets[5].data.push(core.cpuUsed.irq);    // irqPercent
      data.datasets[6].data.push(core.cpuUsed.sirq);   // sirqPercent
      data.datasets[7].data.push(core.cpuUsed.host);   // hostPercent
    });

    // Limit to last 20 points
    const MAX_POINTS = 20;
    if (data.labels.length > MAX_POINTS) {
      data.labels.splice(0, data.labels.length - MAX_POINTS);
      data.datasets.forEach(dataset => {
        dataset.data.splice(0, dataset.data.length - MAX_POINTS);
      });
    }

    try {
      this.chart.update('none');
    } catch (error) {
      console.error('Error updating chart:', error);
    }
  }


  startPeriodicUpdate() {
    if (this.updateInterval) {
      clearInterval(this.updateInterval);
      return;
    }
    this.updateInterval = setInterval(() => {
      if (this.performanceMatrix) {
        this.updateChartData(this.performanceMatrix);
      }
    }, 2000);
    return;
  }
  //for graph

  // generatePerformancePDF() {
  //   // Check if data exists before generating PDF
  //   if (!this.performanceMatrix && !this.performanceData) {
  //     this.msg = 'No performance data available. Please start monitoring first.';
  //     this.openAlertMod(this.alertTemplate, this.msg);
  //     return;
  //   }

  //   const doc = new jsPDF();
  //   const timestamp = new Date().toLocaleString();
  //   let yPosition = 15;

  //   // Title
  //   doc.setFontSize(18);
  //   doc.setFont('helvetica', 'bold');
  //   doc.text('Performance Metrics Report', 105, yPosition, { align: 'center' });

  //   yPosition += 10;
  //   doc.setFontSize(10);
  //   doc.setFont('helvetica', 'normal');
  //   doc.text(`Generated: ${timestamp}`, 105, yPosition, { align: 'center' });
  //   doc.text(`Device: ${this.device.serial || 'N/A'}`, 105, yPosition + 5, { align: 'center' });
  //   doc.text(`App(Package Name): ${this.parsed?.packageName || 'N/A'}`, 105, yPosition + 10, { align: 'center' });

  //   yPosition += 25;

  //   // 1. CPU Performance Metrics
  //   if (this.performanceMatrix && this.performanceHistory.length > 0) {
  //     doc.setFontSize(14);
  //     doc.setFont('helvetica', 'bold');
  //     doc.text('CPU Performance Metrics (Average Values)', 14, yPosition);
  //     yPosition += 8;

  //     // Calculate average CPU usage from history
  //     const avgCpuUsage = this.calculateAverageCPU();

  //     const cpuData = avgCpuUsage.map(cpu => [
  //       `Core ${cpu.coreId}`,
  //       `${cpu.userPercent.toFixed(2)}%`,
  //       `${cpu.nicePercent.toFixed(2)}%`,
  //       `${cpu.sysPercent.toFixed(2)}%`,
  //       `${cpu.idlePercent.toFixed(2)}%`,
  //       `${cpu.iowPercent.toFixed(2)}%`,
  //       `${cpu.irqPercent.toFixed(2)}%`,
  //       `${cpu.sirqPercent.toFixed(2)}%`
  //     ]);

  //     autoTable(doc, {
  //       startY: yPosition,
  //       head: [['Core', 'User', 'Nice', 'System', 'Idle', 'IOW', 'IRQ', 'SIRQ']],
  //       body: cpuData,
  //       theme: 'grid',
  //       headStyles: { fillColor: [66, 165, 245], fontSize: 9 },
  //       bodyStyles: { fontSize: 8 },
  //       margin: { left: 14, right: 14 }
  //     });

  //     yPosition = (doc as any).lastAutoTable.finalY + 10;

  //     // Memory Usage (Average)
  //     doc.setFontSize(12);
  //     doc.setFont('helvetica', 'bold');
  //     doc.text('Memory Usage (Average)', 14, yPosition);
  //     yPosition += 6;

  //     const avgMemory = this.calculateAverageMemory();

  //     autoTable(doc, {
  //       startY: yPosition,
  //       head: [['Metric', 'Value']],
  //       body: [
  //         ['Total Memory', avgMemory.totalMemory],
  //         ['Used Memory', avgMemory.usedMemory],
  //         ['Free Memory', avgMemory.freeMemory],
  //         ['Usage Percentage', `${avgMemory.memoryUsagePercent.toFixed(2)}%`]
  //       ],
  //       theme: 'grid',
  //       headStyles: { fillColor: [102, 187, 106], fontSize: 9 },
  //       bodyStyles: { fontSize: 8 },
  //       margin: { left: 14, right: 14 }
  //     });

  //     yPosition = (doc as any).lastAutoTable.finalY + 10;

  //     // Top Processes (Average)
  //     if (yPosition > 250) {
  //       doc.addPage();
  //       yPosition = 15;
  //     }

  //     doc.setFontSize(12);
  //     doc.setFont('helvetica', 'bold');
  //     doc.text('Top Processes (Average CPU & Memory)', 14, yPosition);
  //     doc.setFontSize(9);
  //     doc.setFont('helvetica', 'normal');
  //     doc.text(`Based on ${this.performanceHistory.length} data points`, 14, yPosition + 4);
  //     yPosition += 10;

  //     const avgProcesses = this.calculateAverageProcesses();
  //     const processData = avgProcesses.slice(0, 10).map(proc => [
  //       proc.pid,
  //       proc.name.substring(0, 25),
  //       `${proc.cpuPercent.toFixed(2)}%`,
  //       proc.memoryUsed,
  //       proc.threadCount.toFixed(0)
  //     ]);

  //     autoTable(doc, {
  //       startY: yPosition,
  //       head: [['PID', 'Process Name', 'Avg CPU %', 'Avg Memory', 'Avg Threads']],
  //       body: processData,
  //       theme: 'grid',
  //       headStyles: { fillColor: [255, 152, 0], fontSize: 9 },
  //       bodyStyles: { fontSize: 8 },
  //       margin: { left: 14, right: 14 }
  //     });

  //     yPosition = (doc as any).lastAutoTable.finalY + 15;
  //   } else if (this.performanceMatrix) {
  //     // Show message if no history but current data exists
  //     doc.setFontSize(12);
  //     doc.setFont('helvetica', 'italic');
  //     doc.text('CPU Performance: Insufficient data for average calculation', 14, yPosition);
  //     yPosition += 10;
  //   }

  //   // 2. App Performance Metrics
  //   if (this.performanceData && this.appPerformanceHistory.length > 0) {
  //     if (yPosition > 240) {
  //       doc.addPage();
  //       yPosition = 15;
  //     }

  //     doc.setFontSize(14);
  //     doc.setFont('helvetica', 'bold');
  //     doc.text('App Performance Metrics (Average Values)', 14, yPosition);
  //     yPosition += 8;

  //     // Calculate average frame statistics
  //     const avgFrameStats = this.calculateAverageFrameStats();

  //     // Calculate average percentiles ONCE here for both frame and GPU
  //     const avgPercentiles = this.calculateAveragePercentiles();

  //     // Frame Statistics
  //     doc.setFontSize(12);
  //     doc.text('Frame Statistics', 14, yPosition);
  //     doc.setFontSize(9);
  //     doc.setFont('helvetica', 'normal');
  //     doc.text(`Based on ${this.appPerformanceHistory.length} data points`, 14, yPosition + 4);
  //     yPosition += 10;

  //     autoTable(doc, {
  //       startY: yPosition,
  //       head: [['Metric', 'Average Value']],
  //       body: [
  //         ['Total Frames', avgFrameStats.totalFrames.toFixed(0)],
  //         ['Janky Frames', avgFrameStats.jankyFrames.toFixed(2)],
  //         ['Missed Vsync', avgFrameStats.missedVsync.toFixed(2)],
  //         ['High Input Latency', avgFrameStats.highInputLatency.toFixed(2)],
  //         ['Slow UI Thread', avgFrameStats.slowUIThread.toFixed(2)],
  //         ['Frame Deadline Missed', avgFrameStats.frameDeadlineMissed.toFixed(2)]
  //       ],
  //       theme: 'grid',
  //       headStyles: { fillColor: [66, 165, 245], fontSize: 9 },
  //       bodyStyles: { fontSize: 8 },
  //       margin: { left: 14, right: 14 }
  //     });

  //     yPosition = (doc as any).lastAutoTable.finalY + 10;

  //     // Frame Percentiles (Average)
  //     if (this.framePercentileChart) {
  //       doc.setFontSize(12);
  //       doc.text('Frame Latency Percentiles (ms) - Average', 14, yPosition);
  //       yPosition += 6;

  //       const framePercentileData = Object.keys(avgPercentiles.frame).map(key => [
  //         key,
  //         `${avgPercentiles.frame[key].toFixed(2)} ms`
  //       ]);

  //       autoTable(doc, {
  //         startY: yPosition,
  //         head: [['Percentile', 'Avg Latency']],
  //         body: framePercentileData,
  //         theme: 'grid',
  //         headStyles: { fillColor: [66, 165, 245], fontSize: 9 },
  //         bodyStyles: { fontSize: 8 },
  //         margin: { left: 14, right: 14 },
  //         columnStyles: { 0: { cellWidth: 50 }, 1: { cellWidth: 50 } }
  //       });

  //       yPosition = (doc as any).lastAutoTable.finalY + 10;
  //     }

  //     // GPU Statistics
  //     if (yPosition > 240) {
  //       doc.addPage();
  //       yPosition = 15;
  //     }

  //     const avgGPUStats = this.calculateAverageGPUStats();

  //     doc.setFontSize(12);
  //     doc.setFont('helvetica', 'bold');
  //     doc.text('GPU Statistics (Average)', 14, yPosition);
  //     yPosition += 6;

  //     autoTable(doc, {
  //       startY: yPosition,
  //       head: [['Metric', 'Average Value']],
  //       body: [
  //         ['Pipeline', this.performanceData.gpuStats.pipeline],
  //         ['Total GPU Memory', `${avgGPUStats.totalGPUMemory.toFixed(2)} MB`],
  //         ['Purgeable GPU Memory', `${avgGPUStats.purgeableGPUBytes.toFixed(2)} MB`]
  //       ],
  //       theme: 'grid',
  //       headStyles: { fillColor: [102, 187, 106], fontSize: 9 },
  //       bodyStyles: { fontSize: 8 },
  //       margin: { left: 14, right: 14 }
  //     });

  //     yPosition = (doc as any).lastAutoTable.finalY + 10;

  //     // GPU Percentiles (Average) - Now avgPercentiles is already defined above
  //     if (this.gpuPercentileChart) {
  //       doc.setFontSize(12);
  //       doc.text('GPU Latency Percentiles (ms) - Average', 14, yPosition);
  //       yPosition += 6;

  //       const gpuPercentileData = Object.keys(avgPercentiles.gpu).map(key => [
  //         key,
  //         `${avgPercentiles.gpu[key].toFixed(2)} ms`
  //       ]);

  //       autoTable(doc, {
  //         startY: yPosition,
  //         head: [['Percentile', 'Avg Latency']],
  //         body: gpuPercentileData,
  //         theme: 'grid',
  //         headStyles: { fillColor: [102, 187, 106], fontSize: 9 },
  //         bodyStyles: { fontSize: 8 },
  //         margin: { left: 14, right: 14 },
  //         columnStyles: { 0: { cellWidth: 50 }, 1: { cellWidth: 50 } }
  //       });

  //       yPosition = (doc as any).lastAutoTable.finalY + 10;
  //     }

  //     // View Hierarchy (Average)
  //     if (yPosition > 240) {
  //       doc.addPage();
  //       yPosition = 15;
  //     }

  //     const avgViewHierarchy = this.calculateAverageViewHierarchy();

  //     doc.setFontSize(12);
  //     doc.text('View Hierarchy (Average)', 14, yPosition);
  //     yPosition += 6;

  //     autoTable(doc, {
  //       startY: yPosition,
  //       head: [['Metric', 'Average Value']],
  //       body: [
  //         ['Total View Roots', avgViewHierarchy.totalViewRoots.toFixed(2)],
  //         ['Total Views', avgViewHierarchy.totalViews.toFixed(2)],
  //         ['Render Node Used', `${avgViewHierarchy.totalRenderNodeUsedKB.toFixed(2)} KB`],
  //         ['Render Node Capacity', `${avgViewHierarchy.totalRenderNodeCapacityKB.toFixed(2)} KB`]
  //       ],
  //       theme: 'grid',
  //       headStyles: { fillColor: [255, 152, 0], fontSize: 9 },
  //       bodyStyles: { fontSize: 8 },
  //       margin: { left: 14, right: 14 }
  //     });
  //   } else if (this.performanceData) {
  //     // Show message if no history but current data exists
  //     doc.setFontSize(12);
  //     doc.setFont('helvetica', 'italic');
  //     doc.text('App Performance: Insufficient data for average calculation', 14, yPosition);
  //     yPosition += 10;
  //   }

  //   // Save the PDF
  //   const fileName = `performance_report_${new Date().getTime()}.pdf`;
  //   doc.save(fileName);
  // }

  generatePerformancePDF() {
    // Check if data exists before generating PDF
    if (!this.performanceMatrix && !this.performanceData && !this.batteryUsage && !this.networkStats) {
      this.msg = 'No performance data available. Please start monitoring first.';
      this.openAlertMod(this.alertTemplate, this.msg);
      return;
    }

    const doc = new jsPDF();
    const timestamp = new Date().toLocaleString();
    let yPosition = 15;

    // Title
    doc.setFontSize(18);
    doc.setFont('helvetica', 'bold');
    doc.text('Performance Metrics Report', 105, yPosition, { align: 'center' });

    yPosition += 10;
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.text(`Generated: ${timestamp} (From: ${this.fromTime || 'N/A'})`, 105, yPosition, { align: 'center' });
    doc.text(`Generated: ${timestamp} (To: ${timestamp || 'N/A'})`, 105, yPosition + 5, { align: 'center' });
    doc.text(`Device: ${this.device.serial || 'N/A'}`, 105, yPosition + 10, { align: 'center' });
    doc.text(`App(Package Name): ${this.parsed?.packageName || 'N/A'}`, 105, yPosition + 15, { align: 'center' });

    yPosition += 25;

    // 1. CPU Performance Metrics
    try {
      if (this.performanceMatrix && this.performanceHistory.length > 0) {
        doc.setFontSize(14);
        doc.setFont('helvetica', 'bold');
        doc.text('CPU Performance Metrics (Average Values)', 14, yPosition);
        yPosition += 8;

        // Calculate average CPU usage from history
        const avgCpuUsage = this.calculateAverageCPU();

        const cpuData = avgCpuUsage.map(cpu => [
          `Core ${cpu.coreId}`,
          `${cpu.userPercent.toFixed(2)}%`,
          `${cpu.nicePercent.toFixed(2)}%`,
          `${cpu.sysPercent.toFixed(2)}%`,
          `${cpu.idlePercent.toFixed(2)}%`,
          `${cpu.iowPercent.toFixed(2)}%`,
          `${cpu.irqPercent.toFixed(2)}%`,
          `${cpu.sirqPercent.toFixed(2)}%`
        ]);

        autoTable(doc, {
          startY: yPosition,
          head: [['Core', 'User', 'Nice', 'System', 'Idle', 'IOW', 'IRQ', 'SIRQ']],
          body: cpuData,
          theme: 'grid',
          headStyles: { fillColor: [66, 165, 245], fontSize: 9 },
          bodyStyles: { fontSize: 8 },
          margin: { left: 14, right: 14 }
        });

        yPosition = (doc as any).lastAutoTable.finalY + 10;

        // Memory Usage (Average)
        doc.setFontSize(12);
        doc.setFont('helvetica', 'bold');
        doc.text('Memory Usage (Average)', 14, yPosition);
        yPosition += 6;

        const avgMemory = this.calculateAverageMemory();

        autoTable(doc, {
          startY: yPosition,
          head: [['Metric', 'Value']],
          body: [
            ['Total Memory', avgMemory.totalMemory],
            ['Used Memory', avgMemory.usedMemory],
            ['Free Memory', avgMemory.freeMemory],
            ['Usage Percentage', `${avgMemory.memoryUsagePercent.toFixed(2)}%`]
          ],
          theme: 'grid',
          headStyles: { fillColor: [102, 187, 106], fontSize: 9 },
          bodyStyles: { fontSize: 8 },
          margin: { left: 14, right: 14 }
        });

        yPosition = (doc as any).lastAutoTable.finalY + 10;

        // Top Processes (Average)
        if (yPosition > 250) {
          doc.addPage();
          yPosition = 15;
        }

        doc.setFontSize(12);
        doc.setFont('helvetica', 'bold');
        doc.text('Top Processes (Average CPU & Memory)', 14, yPosition);
        doc.setFontSize(9);
        doc.setFont('helvetica', 'normal');
        doc.text(`Based on ${this.performanceHistory.length} data points`, 14, yPosition + 4);
        yPosition += 10;

        const avgProcesses = this.calculateAverageProcesses();
        const processData = avgProcesses.slice(0, 10).map(proc => [
          proc.pid,
          proc.name.substring(0, 25),
          `${proc.cpuPercent.toFixed(2)}%`,
          proc.memoryUsed,
          proc.threadCount.toFixed(0)
        ]);

        autoTable(doc, {
          startY: yPosition,
          head: [['PID', 'Process Name', 'Avg CPU %', 'Avg Memory', 'Avg Threads']],
          body: processData,
          theme: 'grid',
          headStyles: { fillColor: [255, 152, 0], fontSize: 9 },
          bodyStyles: { fontSize: 8 },
          margin: { left: 14, right: 14 }
        });

        yPosition = (doc as any).lastAutoTable.finalY + 15;
      } else if (this.performanceMatrix) {
        // Show message if no history but current data exists
        doc.setFontSize(12);
        doc.setFont('helvetica', 'italic');
        doc.text('CPU Performance: Insufficient data for average calculation', 14, yPosition);
        yPosition += 10;
      }
    } catch (err) {
      console.error('Error generating CPU Performance section of PDF:', err);
      doc.setFontSize(12);
      doc.setFont('helvetica', 'italic');
      doc.text('CPU Performance: Unable to generate this section', 14, yPosition);
      yPosition += 10;
    }

    // 2. App Performance Metrics
    try {
      if (this.performanceData && this.appPerformanceHistory.length > 0) {
        if (yPosition > 240) {
          doc.addPage();
          yPosition = 15;
        }

        doc.setFontSize(14);
        doc.setFont('helvetica', 'bold');
        doc.text('App Performance Metrics (Average Values)', 14, yPosition);
        yPosition += 8;

        // Calculate average frame statistics
        const avgFrameStats = this.calculateAverageFrameStats();

        // Calculate average percentiles ONCE here for both frame and GPU
        const avgPercentiles = this.calculateAveragePercentiles();

        // Frame Statistics
        doc.setFontSize(12);
        doc.text('Frame Statistics', 14, yPosition);
        doc.setFontSize(9);
        doc.setFont('helvetica', 'normal');
        doc.text(`Based on ${this.appPerformanceHistory.length} data points`, 14, yPosition + 4);
        yPosition += 10;

        autoTable(doc, {
          startY: yPosition,
          head: [['Metric', 'Average Value']],
          body: [
            ['Total Frames', avgFrameStats.totalFrames.toFixed(0)],
            ['Janky Frames', avgFrameStats.jankyFrames.toFixed(2)],
            ['Missed Vsync', avgFrameStats.missedVsync.toFixed(2)],
            ['High Input Latency', avgFrameStats.highInputLatency.toFixed(2)],
            ['Slow UI Thread', avgFrameStats.slowUIThread.toFixed(2)],
            ['Frame Deadline Missed', avgFrameStats.frameDeadlineMissed.toFixed(2)]
          ],
          theme: 'grid',
          headStyles: { fillColor: [66, 165, 245], fontSize: 9 },
          bodyStyles: { fontSize: 8 },
          margin: { left: 14, right: 14 }
        });

        yPosition = (doc as any).lastAutoTable.finalY + 10;

        // Frame Percentiles (Average)
        if (this.framePercentileChart) {
          doc.setFontSize(12);
          doc.text('Frame Latency Percentiles (ms) - Average', 14, yPosition);
          yPosition += 6;

          const framePercentileData = Object.keys(avgPercentiles.frame).map(key => [
            key,
            `${avgPercentiles.frame[key].toFixed(2)} ms`
          ]);

          autoTable(doc, {
            startY: yPosition,
            head: [['Percentile', 'Avg Latency']],
            body: framePercentileData,
            theme: 'grid',
            headStyles: { fillColor: [66, 165, 245], fontSize: 9 },
            bodyStyles: { fontSize: 8 },
            margin: { left: 14, right: 14 },
            columnStyles: { 0: { cellWidth: 50 }, 1: { cellWidth: 50 } }
          });

          yPosition = (doc as any).lastAutoTable.finalY + 10;
        }

        // GPU Statistics
        if (yPosition > 240) {
          doc.addPage();
          yPosition = 15;
        }

        const avgGPUStats = this.calculateAverageGPUStats();

        doc.setFontSize(12);
        doc.setFont('helvetica', 'bold');
        doc.text('GPU Statistics (Average)', 14, yPosition);
        yPosition += 6;

        autoTable(doc, {
          startY: yPosition,
          head: [['Metric', 'Average Value']],
          body: [
            ['Pipeline', this.performanceData.gpuStats.pipeline],
            ['Total GPU Memory', `${avgGPUStats.totalGPUMemory.toFixed(2)} MB`],
            ['Purgeable GPU Memory', `${avgGPUStats.purgeableGPUBytes.toFixed(2)} MB`]
          ],
          theme: 'grid',
          headStyles: { fillColor: [102, 187, 106], fontSize: 9 },
          bodyStyles: { fontSize: 8 },
          margin: { left: 14, right: 14 }
        });

        yPosition = (doc as any).lastAutoTable.finalY + 10;

        // GPU Percentiles (Average)
        if (this.gpuPercentileChart) {
          doc.setFontSize(12);
          doc.text('GPU Latency Percentiles (ms) - Average', 14, yPosition);
          yPosition += 6;

          const gpuPercentileData = Object.keys(avgPercentiles.gpu).map(key => [
            key,
            `${avgPercentiles.gpu[key].toFixed(2)} ms`
          ]);

          autoTable(doc, {
            startY: yPosition,
            head: [['Percentile', 'Avg Latency']],
            body: gpuPercentileData,
            theme: 'grid',
            headStyles: { fillColor: [102, 187, 106], fontSize: 9 },
            bodyStyles: { fontSize: 8 },
            margin: { left: 14, right: 14 },
            columnStyles: { 0: { cellWidth: 50 }, 1: { cellWidth: 50 } }
          });

          yPosition = (doc as any).lastAutoTable.finalY + 10;
        }

        // View Hierarchy (Average)
        if (yPosition > 240) {
          doc.addPage();
          yPosition = 15;
        }

        const avgViewHierarchy = this.calculateAverageViewHierarchy();

        doc.setFontSize(12);
        doc.text('View Hierarchy (Average)', 14, yPosition);
        yPosition += 6;

        autoTable(doc, {
          startY: yPosition,
          head: [['Metric', 'Average Value']],
          body: [
            ['Total View Roots', avgViewHierarchy.totalViewRoots.toFixed(2)],
            ['Total Views', avgViewHierarchy.totalViews.toFixed(2)],
            ['Render Node Used', `${avgViewHierarchy.totalRenderNodeUsedKB.toFixed(2)} KB`],
            ['Render Node Capacity', `${avgViewHierarchy.totalRenderNodeCapacityKB.toFixed(2)} KB`]
          ],
          theme: 'grid',
          headStyles: { fillColor: [255, 152, 0], fontSize: 9 },
          bodyStyles: { fontSize: 8 },
          margin: { left: 14, right: 14 }
        });

        yPosition = (doc as any).lastAutoTable.finalY + 10;
      } else if (this.performanceData) {
        // Show message if no history but current data exists
        doc.setFontSize(12);
        doc.setFont('helvetica', 'italic');
        doc.text('App Performance: Insufficient data for average calculation', 14, yPosition);
        yPosition += 10;
      }
    } catch (err) {
      console.error('Error generating App Performance section of PDF:', err);
      doc.setFontSize(12);
      doc.setFont('helvetica', 'italic');
      doc.text('App Performance: Unable to generate this section', 14, yPosition);
      yPosition += 10;
    }

    // 3. Battery Usage Statistics
    try {
      if (this.batteryUsage) {
        if (yPosition > 220) {
          doc.addPage();
          yPosition = 15;
        }

        doc.setFontSize(14);
        doc.setFont('helvetica', 'bold');
        doc.text('Battery Usage Statistics', 14, yPosition);
        yPosition += 8;

        doc.setFontSize(12);
        doc.text('Battery Information', 14, yPosition);
        yPosition += 6;

        autoTable(doc, {
          startY: yPosition,
          head: [['Metric', 'Value']],
          body: [
            ['Battery Capacity', `${this.batteryUsage.estimatedBatteryCapacity || 0} mAh`],
            ['Total Discharge', `${this.batteryUsage.dischargeMah || 0} mAh`],
            ['Screen Off Discharge', `${this.batteryUsage.screenOffDischargeMah || 0} mAh`],
            ['Screen On Discharge', `${this.batteryUsage.screenOnDischargeMah || 0} mAh`],
            ['Screen Power', `${(this.batteryUsage.screenPowerMah || 0).toFixed(2)} mAh`],
            ['CPU Power', `${(this.batteryUsage.cpuPowerMah || 0).toFixed(2)} mAh`],
            ['Time on Battery', this.formatTime(this.batteryUsage.timeOnBatteryMs || 0)],
            ['Screen On Time', this.formatTime(this.batteryUsage.screenOnTimeMs || 0)],
            ['Wake Locks', `${this.batteryUsage.wakeLocks || 0}`]
          ],
          theme: 'grid',
          headStyles: { fillColor: [244, 67, 54], fontSize: 9 },
          bodyStyles: { fontSize: 8 },
          margin: { left: 14, right: 14 }
        });

        yPosition = (doc as any).lastAutoTable.finalY + 10;
      }
    } catch (err) {
      console.error('Error generating Battery Usage section of PDF:', err);
      doc.setFontSize(12);
      doc.setFont('helvetica', 'italic');
      doc.text('Battery Usage: Unable to generate this section', 14, yPosition);
      yPosition += 10;
    }

    // 4. Network Statistics
    try {
      if (this.networkStats) {
        if (yPosition > 200) {
          doc.addPage();
          yPosition = 15;
        }

        doc.setFontSize(14);
        doc.setFont('helvetica', 'bold');
        doc.text('Network Statistics', 14, yPosition);
        yPosition += 8;

        doc.setFontSize(12);
        doc.text('WiFi Usage', 14, yPosition);
        yPosition += 6;

        autoTable(doc, {
          startY: yPosition,
          head: [['Metric', 'Value']],
          body: [
            ['Data Received', `${((this.networkStats.wifiRxBytes || 0) / 1024 / 1024).toFixed(2)} MB`],
            ['Data Sent', `${((this.networkStats.wifiTxBytes || 0) / 1024 / 1024).toFixed(2)} MB`],
            ['Packets Received', `${(this.networkStats.wifiRxPackets || 0).toLocaleString()}`],
            ['Packets Sent', `${(this.networkStats.wifiTxPackets || 0).toLocaleString()}`],
            ['Active Time', this.formatTime(this.networkStats.wifiKernelActiveTimeMs || 0)]
          ],
          theme: 'grid',
          headStyles: { fillColor: [33, 150, 243], fontSize: 9 },
          bodyStyles: { fontSize: 8 },
          margin: { left: 14, right: 14 }
        });

        yPosition = (doc as any).lastAutoTable.finalY + 8;

        doc.setFontSize(12);
        doc.text('Mobile Data Usage', 14, yPosition);
        yPosition += 6;

        autoTable(doc, {
          startY: yPosition,
          head: [['Metric', 'Value']],
          body: [
            ['Data Received', `${((this.networkStats.mobileRxBytes || 0) / 1024 / 1024).toFixed(2)} MB`],
            ['Data Sent', `${((this.networkStats.mobileTxBytes || 0) / 1024 / 1024).toFixed(2)} MB`],
            ['Packets Received', `${(this.networkStats.mobileRxPackets || 0).toLocaleString()}`],
            ['Packets Sent', `${(this.networkStats.mobileTxPackets || 0).toLocaleString()}`],
            ['Active Time', this.formatTime(this.networkStats.cellularKernelActiveTimeMs || 0)]
          ],
          theme: 'grid',
          headStyles: { fillColor: [76, 175, 80], fontSize: 9 },
          bodyStyles: { fontSize: 8 },
          margin: { left: 14, right: 14 }
        });

        yPosition = (doc as any).lastAutoTable.finalY + 8;

        doc.setFontSize(12);
        doc.text('Total Network Usage', 14, yPosition);
        yPosition += 6;

        autoTable(doc, {
          startY: yPosition,
          head: [['Metric', 'Value']],
          body: [
            ['Total Data Received', `${((this.networkStats.totalRxBytes || 0) / 1024 / 1024).toFixed(2)} MB`],
            ['Total Data Sent', `${((this.networkStats.totalTxBytes || 0) / 1024 / 1024).toFixed(2)} MB`],
            ['Total Data', `${(((this.networkStats.totalRxBytes || 0) + (this.networkStats.totalTxBytes || 0)) / 1024 / 1024).toFixed(2)} MB`]
          ],
          theme: 'grid',
          headStyles: { fillColor: [156, 39, 176], fontSize: 9 },
          bodyStyles: { fontSize: 8 },
          margin: { left: 14, right: 14 }
        });

        yPosition = (doc as any).lastAutoTable.finalY + 10;
      }
    } catch (err) {
      console.error('Error generating Network Statistics section of PDF:', err);
      doc.setFontSize(12);
      doc.setFont('helvetica', 'italic');
      doc.text('Network Statistics: Unable to generate this section', 14, yPosition);
      yPosition += 10;
    }

    // Save the PDF
    const fileName = `performance_report_${new Date().getTime()}.pdf`;
    doc.save(fileName);
  }


  // Helper methods to calculate averages

  private calculateAverageCPU() {
    if (this.performanceHistory.length === 0) return [];

    const avgData = [];
    // Use the max core count seen across all snapshots, not just the first one
    const coresCount = this.performanceHistory.reduce(
      (max, snapshot) => Math.max(max, snapshot.cpuUsage?.length || 0),
      0
    );

    for (let i = 0; i < coresCount; i++) {
      let sumUser = 0, sumNice = 0, sumSys = 0, sumIdle = 0;
      let sumIow = 0, sumIrq = 0, sumSirq = 0, sumHost = 0;
      let validCount = 0;

      this.performanceHistory.forEach(snapshot => {
        const core = snapshot.cpuUsage?.[i];
        if (!core) return; // skip snapshots missing this core

        sumUser += core.userPercent || 0;
        sumNice += core.nicePercent || 0;
        sumSys += core.sysPercent || 0;
        sumIdle += (core.idlePercent || 0) / this.cpuCores; // Adjust idle percent
        sumIow += core.iowPercent || 0;
        sumIrq += core.irqPercent || 0;
        sumSirq += core.sirqPercent || 0;
        sumHost += core.hostPercent || 0;
        validCount++;
      });

      if (validCount === 0) continue; // no data for this core at all, skip it

      avgData.push({
        coreId: i + 1,
        userPercent: sumUser / validCount,
        nicePercent: sumNice / validCount,
        sysPercent: sumSys / validCount,
        idlePercent: sumIdle / validCount,
        iowPercent: sumIow / validCount,
        irqPercent: sumIrq / validCount,
        sirqPercent: sumSirq / validCount,
        hostPercent: sumHost / validCount
      });
    }

    return avgData;
  }

  private calculateAverageMemory() {
    if (this.performanceHistory.length === 0) return {
      totalMemory: '0K',
      usedMemory: '0K',
      freeMemory: '0K',
      memoryUsagePercent: 0
    };

    let sumPercent = 0;
    let totalMemory = this.performanceHistory[0].totalMemory;

    this.performanceHistory.forEach(snapshot => {
      sumPercent += snapshot.memoryUsagePercent;
    });

    const avgPercent = sumPercent / this.performanceHistory.length;

    return {
      totalMemory: totalMemory,
      usedMemory: `${((parseFloat(totalMemory) * avgPercent) / 100).toFixed(0)}K used`,
      freeMemory: `${(parseFloat(totalMemory) * (100 - avgPercent) / 100).toFixed(0)}K free`,
      memoryUsagePercent: avgPercent
    };
  }

  private calculateAverageProcesses() {
    if (this.performanceHistory.length === 0) return [];

    const processMap = new Map();

    this.performanceHistory.forEach(snapshot => {
      snapshot.processes.forEach(proc => {
        if (!processMap.has(proc.pid)) {
          processMap.set(proc.pid, {
            pid: proc.pid,
            name: proc.name,
            cpuSum: 0,
            memorySum: 0,
            threadSum: 0,
            count: 0
          });
        }
        const entry = processMap.get(proc.pid);
        entry.cpuSum += proc.cpuPercent;
        entry.memorySum += parseFloat(proc.memoryUsed);
        entry.threadSum += proc.threadCount;
        entry.count++;
      });
    });

    const avgProcesses = Array.from(processMap.values()).map(proc => ({
      pid: proc.pid,
      name: proc.name,
      cpuPercent: proc.cpuSum / proc.count,
      memoryUsed: `${(proc.memorySum / proc.count).toFixed(1)}M`,
      threadCount: proc.threadSum / proc.count
    }));

    return avgProcesses.sort((a, b) => b.cpuPercent - a.cpuPercent);
  }

  private calculateAverageFrameStats() {
    if (this.appPerformanceHistory.length === 0) return {
      totalFrames: 0,
      jankyFrames: 0,
      missedVsync: 0,
      highInputLatency: 0,
      slowUIThread: 0,
      frameDeadlineMissed: 0
    };

    const sum = {
      totalFrames: 0,
      jankyFrames: 0,
      missedVsync: 0,
      highInputLatency: 0,
      slowUIThread: 0,
      frameDeadlineMissed: 0
    };

    this.appPerformanceHistory.forEach(snapshot => {
      sum.totalFrames += snapshot.frames.totalFrames;
      sum.jankyFrames += snapshot.frames.jankyFrames;
      sum.missedVsync += snapshot.frames.missedVsync;
      sum.highInputLatency += snapshot.frames.highInputLatency;
      sum.slowUIThread += snapshot.frames.slowUIThread;
      sum.frameDeadlineMissed += snapshot.frames.frameDeadlineMissed;
    });

    const count = this.appPerformanceHistory.length;
    return {
      totalFrames: sum.totalFrames / count,
      jankyFrames: sum.jankyFrames / count,
      missedVsync: sum.missedVsync / count,
      highInputLatency: sum.highInputLatency / count,
      slowUIThread: sum.slowUIThread / count,
      frameDeadlineMissed: sum.frameDeadlineMissed / count
    };
  }

  private calculateAveragePercentiles() {
    if (this.appPerformanceHistory.length === 0) return {
      frame: { p50: 0, p90: 0, p95: 0, p99: 0 },
      gpu: { p50: 0, p90: 0, p95: 0, p99: 0 }
    };

    const frameSum = { p50: 0, p90: 0, p95: 0, p99: 0 };
    const gpuSum = { p50: 0, p90: 0, p95: 0, p99: 0 };

    this.appPerformanceHistory.forEach(snapshot => {
      frameSum.p50 += snapshot.frames.percentiles.p50;
      frameSum.p90 += snapshot.frames.percentiles.p90;
      frameSum.p95 += snapshot.frames.percentiles.p95;
      frameSum.p99 += snapshot.frames.percentiles.p99;

      gpuSum.p50 += snapshot.gpuStats.gpuPercentiles.p50;
      gpuSum.p90 += snapshot.gpuStats.gpuPercentiles.p90;
      gpuSum.p95 += snapshot.gpuStats.gpuPercentiles.p95;
      gpuSum.p99 += snapshot.gpuStats.gpuPercentiles.p99;
    });

    const count = this.appPerformanceHistory.length;
    return {
      frame: {
        p50: frameSum.p50 / count,
        p90: frameSum.p90 / count,
        p95: frameSum.p95 / count,
        p99: frameSum.p99 / count
      },
      gpu: {
        p50: gpuSum.p50 / count,
        p90: gpuSum.p90 / count,
        p95: gpuSum.p95 / count,
        p99: gpuSum.p99 / count
      }
    };
  }

  private calculateAverageGPUStats() {
    if (this.appPerformanceHistory.length === 0) return {
      totalGPUMemory: 0,
      purgeableGPUBytes: 0
    };

    let sumTotalGPU = 0;
    let sumPurgeable = 0;

    this.appPerformanceHistory.forEach(snapshot => {
      sumTotalGPU += snapshot.gpuCaches.totalGPUMemoryBytes / 1024 / 1024;
      sumPurgeable += snapshot.gpuCaches.purgeableGPUBytes;
    });

    const count = this.appPerformanceHistory.length;
    return {
      totalGPUMemory: sumTotalGPU / count,
      purgeableGPUBytes: sumPurgeable / count
    };
  }

  private calculateAverageViewHierarchy() {
    if (this.appPerformanceHistory.length === 0) return {
      totalViewRoots: 0,
      totalViews: 0,
      totalRenderNodeUsedKB: 0,
      totalRenderNodeCapacityKB: 0
    };

    const sum = {
      totalViewRoots: 0,
      totalViews: 0,
      totalRenderNodeUsedKB: 0,
      totalRenderNodeCapacityKB: 0
    };

    this.appPerformanceHistory.forEach(snapshot => {
      sum.totalViewRoots += snapshot.viewHierarchy.totalViewRoots;
      sum.totalViews += snapshot.viewHierarchy.totalViews;
      sum.totalRenderNodeUsedKB += snapshot.viewHierarchy.totalRenderNodeUsedKB;
      sum.totalRenderNodeCapacityKB += snapshot.viewHierarchy.totalRenderNodeCapacityKB;
    });

    const count = this.appPerformanceHistory.length;
    return {
      totalViewRoots: sum.totalViewRoots / count,
      totalViews: sum.totalViews / count,
      totalRenderNodeUsedKB: sum.totalRenderNodeUsedKB / count,
      totalRenderNodeCapacityKB: sum.totalRenderNodeCapacityKB / count
    };
  }
}